export default {
  cacheLoginOnce: 'cacheLoginOnce',
}
